import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { replayDrawing } from "../state/engine-bridge.svelte";
import { art, copyShareLink, randomize, randomizeSettings } from "../state/params.svelte";
import ExportMenu from "./ExportMenu.svelte";
import { showToast } from "./Toast.svelte";

var root = $.from_html(`<button title="Replay the drawing (P)" class="svelte-321j3qmtzkqxv">Replay</button>`);
var root_1 = $.from_html(`<button title="Play / pause (P)" class="svelte-321j3qmtzkqxv"> </button>`);
var root_2 = $.from_html(`<div class="bar svelte-321j3qmtzkqxv"><button title="New seed (R)" class="svelte-321j3qmtzkqxv">New seed</button> <button title="Randomize settings (Space)" class="svelte-321j3qmtzkqxv">Shuffle</button> <!> <div class="export svelte-321j3qmtzkqxv"><button title="Export PNG (E)" class="svelte-321j3qmtzkqxv"> </button> <!></div> <button title="Copy share link (C)" class="svelte-321j3qmtzkqxv">Share</button></div>`);

export default function ActionBar($$anchor, $$props) {
	$.push($$props, true);

	let exportWrap = $.state(void 0);

	async function share() {
		const ok = await copyShareLink();

		showToast(ok
			? "Link copied"
			: "Copy failed — the link is in the address bar");
	}

	// While the export popover is open, any pointerdown outside its wrap
	// (toggle button included) closes it.
	$.user_effect(() => {
		if (!art.exportMenuOpen) return;

		const onDown = (e) => {
			if ($.get(exportWrap) && e.target instanceof Node && !$.get(exportWrap).contains(e.target)) {
				art.exportMenuOpen = false;
			}
		};

		window.addEventListener("pointerdown", onDown, true);

		return () => window.removeEventListener("pointerdown", onDown, true);
	});

	var div = root_2();
	var button = $.child(div);
	var button_1 = $.sibling(button, 2);
	var node = $.sibling(button_1, 2);

	{
		var consequent = ($$anchor) => {
			var button_2 = root();

			$.delegated('click', button_2, () => replayDrawing());
			$.append($$anchor, button_2);
		};

		var alternate = ($$anchor) => {
			var button_3 = root_1();
			var text = $.child(button_3, true);

			$.reset(button_3);
			$.template_effect(() => $.set_text(text, art.paused ? "Play" : "Pause"));
			$.delegated('click', button_3, () => art.paused = !art.paused);
			$.append($$anchor, button_3);
		};

		$.if(node, ($$render) => {
			if (art.settled) $$render(consequent); else $$render(alternate, -1);
		});
	}

	var div_1 = $.sibling(node, 2);
	var button_4 = $.child(div_1);
	var text_1 = $.child(button_4, true);

	$.reset(button_4);

	var node_1 = $.sibling(button_4, 2);

	{
		var consequent_1 = ($$anchor) => {
			ExportMenu($$anchor, {});
		};

		$.if(node_1, ($$render) => {
			if (art.exportMenuOpen) $$render(consequent_1);
		});
	}

	$.reset(div_1);
	$.bind_this(div_1, ($$value) => $.set(exportWrap, $$value), () => $.get(exportWrap));

	var button_5 = $.sibling(div_1, 2);

	$.reset(div);

	$.template_effect(() => {
		$.set_attribute(button_4, 'aria-expanded', art.exportMenuOpen);
		button_4.disabled = art.exporting;
		$.set_text(text_1, art.exporting ? "Exporting…" : "Export");
	});

	$.delegated('click', button, () => randomize());
	$.delegated('click', button_1, () => randomizeSettings());
	$.delegated('click', button_4, () => art.exportMenuOpen = !art.exportMenuOpen);
	$.delegated('click', button_5, share);
	$.append($$anchor, div);
	$.pop();
}

$.delegate(['click']);
import "bun-svelte:ActionBar.svelte-3c143miqirth7-style.css";